import * as api from "../Services/api.js";
import Language from "../../objs/Language";
import Provider from "../../objs/Provider";

export const state = {
  aarLocations: [],
  languages: [],
  statuses: [],
  idepRecommendations: [],
  assessors: [],
  usStates: ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'],
};
export const mutations = {
  SET_OPTIONS(state, payload) {
    state.aarLocations = payload.aarLocations;
    state.languages = payload.languages.map((x) => new Language(x));
    state.statuses = payload.mtaAppointmentStatuses;
    state.idepRecommendations = payload.idepRecommendations;
    state.assessors = payload.assessors.map((x) => new Provider(x));
  },
};
export const getters = {};
export const actions = {
  async getOptions({ commit }) {
    return await api.get("/options/mtaOptions").then((response) => {
      if (response.success) {
        commit("SET_OPTIONS", response.data);
      }
      return response.success;
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
